import { render, staticRenderFns } from "./finalPrice.vue?vue&type=template&id=0ebb6042&scoped=true"
import script from "./finalPrice.vue?vue&type=script&lang=js"
export * from "./finalPrice.vue?vue&type=script&lang=js"
import style0 from "./finalPrice.vue?vue&type=style&index=0&id=0ebb6042&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb6042",
  null
  
)

export default component.exports